module.exports = __webpack_public_path__ + "img/arrow.e75e8586.svg";